module.exports = "pegasus_template/assets/blocks/tile-layout-14.png";